import { render, staticRenderFns } from "./GenreInput.vue?vue&type=template&id=8ce570ac"
import script from "./GenreInput.vue?vue&type=script&lang=js"
export * from "./GenreInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports